// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"b26a5507","343":"b26a5507","450":"c22e0dc5","549":"c22e0dc5"}[chunkId] + ".chunk.css";
};